/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useEffect,
    useState,
} from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import VisibilityIcon from '@material-ui/icons/Visibility';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import DescriptionRoundedIcon from '@material-ui/icons/DescriptionRounded';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
    visualmenteEscondido: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    tableWrapper: {
        // maxHeight: 440,
        overflow: 'auto',
    },
    iconButtonLabelWrapper: {
        display: 'flex',
        padding: 5,
        flexDirection: 'column',
    },
    iconButtonLabel: {
        fontSize: '0.6rem'
    },
}))

export default function Tabela(props) {

    const classes = useStyles();

    const { listaRegistros, alterar, colunas, controlaAlterar, pessoaToNfe } = props;
    const [ordena, setOrdena] = useState('asc');
    const [ordenaPor, setOrdenaPor] = useState();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [columns, setColumns] = useState(props.propsColumns);

    useEffect(() => {
        setColumns(colunas);
    }, [])

    function createData(parametro) {
        return parametro
    }

    const controlaChamaSort = (event, property) => {
        const isAsc = ordenaPor === property && ordena === 'asc';
        setOrdena(isAsc ? 'desc' : 'asc');
        setOrdenaPor(property)
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    function TableHeadSort(props) {
        const { classes, ordena, ordenaPor, chamaSort } = props;
        const criaControlaSort = property => event => {
            chamaSort(event, property);
        }

        return (
            <TableHead>
                <TableRow>
                    <TableCell>Ação</TableCell>
                    {columns && columns.map(column => (
                        <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                            sortDirection={ordenaPor === column.id ? ordena : false}
                        >
                            <TableSortLabel
                                active={ordenaPor === column.id}
                                direction={ordenaPor === column.id ? ordena : 'asc'}
                                onClick={criaControlaSort(column.id)}
                            >
                                {column.label}
                                {ordenaPor === column.id ? (
                                    <span className={classes.visualmenteEscondido}>
                                        {ordena === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        )

    }

    TableHeadSort.propTypes = {
        classes: PropTypes.object.isRequired,
        chamaSort: PropTypes.func.isRequired,
        ordena: PropTypes.oneOf(['asc', 'desc']).isRequired,
        ordenaPor: PropTypes.string.isRequired,
    };

    function desc(a, b, ordenaPor) {
        if (b[ordenaPor] < a[ordenaPor]) {
            return -1;
        }
        if (b[ordenaPor] > a[ordenaPor]) {
            return 1;
        }
        return 0;
    }

    function estabilizaSort(array, cmp) {
        const estabilizado = array.map((el, index) => [el, index]);
        estabilizado.sort((a, b) => {
            const ordena = cmp(a[0], b[0]);
            if (ordena !== 0) return ordena;
            return a[1] - b[1];
        });
        return estabilizado.map(el => el[0]);
    }

    function trazSort(ordena, ordenaPor) {
        return ordena === 'desc' ? (a, b) => desc(a, b, ordenaPor) : (a, b) => -desc(a, b, ordenaPor);
    }

    let rows = [];
    if (listaRegistros) {
        let arrayTemp = [];
        columns && listaRegistros.map(pessoa => {
            let dadosRetorno = {};
            let pessoaKeys = Object.keys(pessoa);
            columns.map((column, index) => {
                dadosRetorno[pessoaKeys[index]] = pessoa[pessoaKeys[index]];
                arrayTemp.push(dadosRetorno);
            })
            rows.push(dadosRetorno);
        })
    } else {
        rows.push(createData(''));
    }

    return (
        <Paper className={classes.root}>
            <div className={classes.tableWrapper}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHeadSort
                        classes={classes}
                        ordena={ordena}
                        ordenaPor={ordenaPor}
                        chamaSort={controlaChamaSort}
                    />
                    <TableBody>
                        {columns && estabilizaSort(rows, trazSort(ordena, ordenaPor))
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map(row => {
                                return (
                                    <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        onDoubleClick={() => alterar(row[Object.keys(row)[0]])}
                                        key={row.code}
                                    >
                                        <TableCell>
                                            <Grid container>
                                                <Grid item xs={6}>
                                                    <IconButton
                                                        aria-label="alterar"
                                                        classes={{ label: classes.iconButtonLabelWrapper }}
                                                        className={controlaAlterar ? classes.visualmenteEscondido : null}
                                                        onClick={() => alterar(row[Object.keys(row)[0]])}
                                                    >
                                                        {row.LAUTORIZADA == "Sim" ? <VisibilityIcon /> : <EditRoundedIcon />}
                                                        <Typography
                                                            variant="body1"
                                                            className={classes.iconButtonLabel}
                                                        >
                                                            {row.LAUTORIZADA == "Sim" ? "Visualizar" : "Editar"}
                                                        </Typography>
                                                    </IconButton>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <IconButton
                                                        aria-label="NFe"
                                                        classes={{ label: classes.iconButtonLabelWrapper }}
                                                        className={!row.CCDPESS ? classes.visualmenteEscondido : null}
                                                        onClick={() => pessoaToNfe(row[Object.keys(row)[0]], row[Object.keys(row)[1]])}
                                                    >
                                                        <DescriptionRoundedIcon />
                                                        <Typography
                                                            variant="body1"
                                                            className={classes.iconButtonLabel}
                                                        >
                                                            Criar NF
                                                        </Typography>
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                        {columns.map(column => {
                                            const value = row[column.id];
                                            return (
                                                <TableCell key={column.id} align={column.align}>
                                                    {column.format && typeof value === 'number' ?
                                                        column.format(value)
                                                        : value}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </div>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Paper>
    )
}